import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { StyleSheet, css } from 'aphrodite';
import Feature1 from '../../../assets/images/features/feature_box1.jpg'
import Feature2 from '../../../assets/images/features/feature_box2.jpg'
import Feature3 from '../../../assets/images/features/feature_box3.jpg'
import Feature4 from '../../../assets/images/features/feature_box4.jpg'

const styles = StyleSheet.create({
    title: {
        fontSize: '20px',
        fontWeight: 700,
        
    }, text: {
        fontSize: '16px',
    },
    box: {
        margin: '50px 0'
    }
});

function mapStateToProps(state) {
    return {

    };
}

class Servicio extends Component {
    render() {
        return (
            <Container className="my-5">
                <Row>
                    <Col md={3} className={css(styles.box)}>
                        <p className={css(styles.title)}>
                            Recolectamos todo en tu domicilio, para que tu no tengas que hacer nada.
                        </p>
                        <p className={css(styles.text)}>
                            Así es, ni cargas ni transportas, nos encargamos nosotros.
                        </p>
                    </Col>
                    <Col md={3} className="d-flex justify-content-center align-items-center">
                        <img src={Feature1} className="img-fluid" />
                    </Col>
                    <Col md={3} className={css(styles.box)}>
                        <p className={css(styles.title)}>
                            La seguridad y cuidado que tus cosas merecen.
                        </p>
                        <p className={css(styles.text)}>
                            Tus cosas se guardan y emplayan de forma profesional. Nuestras Macrobodegas cuentan con circuito cerrado de cámaras, vigilancia 24/7 y medidas de seguridad de primer nivel.
                        </p>
                    </Col>
                    <Col md={3} className="d-flex justify-content-center align-items-center">
                        <img src={Feature2} className="img-fluid" />
                    </Col>
                    <Col md={3} className={css(styles.box)}>
                        <p className={css(styles.title)}>
                            Siempre sabrás lo que tienes guardado.
                        </p>
                        <p className={css(styles.text)}>
                            Tu cuenta tendrá un inventario online de todas tus cosas. Además, tendrás todo asegurado sin pagar más.
                        </p>
                    </Col>
                    <Col md={3} className="d-flex justify-content-center align-items-center">
                        <img src={Feature3} className="img-fluid" />
                    </Col>
                    <Col md={3} className={css(styles.box)}>
                        <p className={css(styles.title)}>
                            Te entregamos cuando digas, donde digas.
                        </p>
                        <p className={css(styles.text)}>
                            Solo debes seleccionar lo que necesites y lo llevaremos a la brevedad, mientras tu sigues sin hacer esfuerzo alguno.
                        </p>
                    </Col>
                    <Col md={3} className="d-flex justify-content-center align-items-center">
                        <img src={Feature4} className="img-fluid" />
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect(
    mapStateToProps,
)(Servicio);